// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation___5B7s","active":"Navigation_active__1LHB4"};